/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type RatesAndInternalCostLitePage_company = {
    readonly id: string;
    readonly currency: string | null;
    readonly " $refType": "RatesAndInternalCostLitePage_company";
};
export type RatesAndInternalCostLitePage_company$data = RatesAndInternalCostLitePage_company;
export type RatesAndInternalCostLitePage_company$key = {
    readonly " $data"?: RatesAndInternalCostLitePage_company$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"RatesAndInternalCostLitePage_company">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "RatesAndInternalCostLitePage_company",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "currency",
      "storageKey": null
    }
  ],
  "type": "Company"
};
(node as any).hash = '53fe65a4967f3cea68719b3ff09f1710';
export default node;
